module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0079.jpg?v=78af4b60";